module.exports = __webpack_public_path__ + "img/lost-downArrow.4a715b97.svg";